<template>
  <div>
    <h4
      class="d-flex justify-content-between align-items-center w-100 font-weight-bold py-3 mb-4"
    >
      <div class="e-mtavr-15">
        USA-ს მიერ სანქცირებული პირები
      </div>
      <!-- <button class="btn btn-primary" @click="refreshToken">a</button> -->
    </h4>

    <div class="row mt-5">
      <div class="e-loader-back" v-if="loading">
            <div class="e-loader-content">
              <div class="ball-clip-rotate-multiple">
                <div></div>
                <div></div>
              </div>
              <div class="e-nusx-8 e-bold e-loader-text">იტვირთება...</div>
            </div>
          </div>
      <div class="col-lg-12 col-sm-12 col-md-12 col-xs-12">
        <b-tabs class="nav-tabs-top mb-4">
          <b-tab active class="bg-transparent">
            <template #title>
            <a href="javascript:void(0)" class="media align-items-center bg-transparent text-body py-3 px-4">
            <div class="lnr lnr-users ui-w-30 text-center text-xlarge"></div>
            <div class="media-body ml-3 e-mtavr-15">
              ფიზიკური პირები
              <!-- <div class="small e-nusx-8">სანქცირებულ ფიზიკურ პირთა სიაში მომხდარი განახლებები</div> -->
            </div>
          </a>
             </template>
            <div class="card-body">
              <div class="row row-bordered no-gutters">
                <div class="col-12">
                  <div class="row">
                    <div class="col-12">
                        <div class="row">
                          <div class="col-lg-2 col-sm-2 col-xs-2 col-md-2 g-mb-40 g-mb-0--lg">
                            <div class="g-mb-20">
                              <span class="e-nusx-7">განახლების თარიღები</span>
                            </div>
                            <b-list-group class="account-settings-links" flush>
                               <b-list-group-item button :active="thistab() === d" @click="changeTab(d), loadUpdateData(d)" class="nav-link e-nusx-8 e-ts-08rem e-text-eng-1 e-ts-14" v-for="d in updateDates" :key="d.$index">{{ d | momentDate }}</b-list-group-item>
                            </b-list-group>
                          </div>
                          <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10" v-if="updateDetailItemList.length > 0">
                            <div class="g-mb-20">
                              <span class="e-nusx-7">განახლების დეტალები</span>
                            </div>
                            <table class="table u-table--v1 mb-0" style="max-width: 100%!important">
                              <thead>
                                <tr class="e-nusx-8">
                                  <th>უნიკალური კოდი</th>
                                  <th>დასახელება</th>
                                  <th>სქესი</th>
                                  <th>მოქალაქეობა</th>
                                  <th>ბაზები</th>
                                  <th>სანქციები</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="up in updateDetailItemList" :key="up.$index">
                                  <td>{{ up.qrCode }}</td>
                                  <td>{{ up.firstName }} {{ up.middleName }} {{ up.lastName }}</td>
                                  <td>{{ up.gender }}</td>
                                  <td><span v-for="c in JSON.parse(up.nationalities)" :key="c.$index">{{ }}</span>
                                    <ul class="list-unstyled">
                                      <li v-for="c in JSON.parse(up.nationalities)" :key="c.$index">
                                          <div class="badge ml-1 mr-1 float-left">{{getCountryFullName(c) }},</div>
                                      </li>
                                    </ul>
                                  </td>
                                  <td>
                                    <ul class="list-unstyled">
                                      <li v-for="n in objectArray(up.datasets)" :key="n.$index">
                                          <div class="badge badge-outline-danger ml-1 mr-1 float-left mt-1">{{n}}</div>
                                      </li>
                                    </ul>
                                  </td>
                                  <td>{{ up.sanOriginTypes }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab>
             <template #title>
              <a href="javascript:void(0)" class="media align-items-center bg-transparent text-body py-3 px-4">
                <div class="lnr lnr-apartment ui-w-30 text-center text-xlarge"></div>
                <div class="media-body ml-3 e-mtavr-15">
                იურიდიული პირები
                <!-- <div class="small e-nusx-8">სანქცირებულ იურიდიულ პირთა სია</div> -->
                </div>
              </a>
             </template>
             <div class="card-body">
              <div class="row row-bordered no-gutters">
                <div class="col-12">
                  <div class="row">
                    <div class="col-12">
                        <div class="row">
                          <div class="col-lg-2 col-sm-2 col-xs-2 col-md-2 g-mb-40 g-mb-0--lg">
                            <div class="g-mb-20">
                              <span class="e-nusx-7">განახლების თარიღები</span>
                            </div>
                            <b-list-group class="account-settings-links" flush>
                               <b-list-group-item button :active="thistabENT() === d" @click="changeTabENT(d), loadUpdateDataENT(d)" class="nav-link e-nusx-8 e-ts-08rem e-text-eng-1 e-ts-14" v-for="d in updateDatesENT" :key="d.$index">{{ d | momentDate }}</b-list-group-item>
                            </b-list-group>
                          </div>
                          <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10" v-if="updateDetailItemListENT.length > 0">
                            <div class="g-mb-20">
                              <span class="e-nusx-7">განახლების დეტალები</span>
                            </div>
                            <table class="table u-table--v1 mb-0" style="max-width: 100%!important">
                              <thead>
                                <tr class="e-nusx-8">
                                  <th>უნიკალური კოდი</th>
                                  <th>დასახელება</th>
                                  <th>ბაზები</th>
                                  <th>სანქციები</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="up in updateDetailItemListENT" :key="up.$index">
                                  <td>{{ up.qrCode }}</td>
                                  <td>{{ up.name }}</td>
                                  <td>
                                    <ul class="list-unstyled">
                                      <li v-for="n in objectArray(up.datasets)" :key="n.$index">
                                          <div class="badge badge-outline-danger ml-1 mr-1 float-left mt-1">{{n}}</div>
                                      </li>
                                    </ul>
                                  </td>
                                  <td>{{ up.sanOriginTypes }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <update-details :update= "updateItem"></update-details>
    <update-details-ent :update= "updateItem"></update-details-ent>
  </div>
</template>

<script>
import BaseService from '@/backend/vue-axios/axios.js'
import moment from 'moment'
import 'loaders.css/loaders.css'
import 'spinkit/spinkit.css'
import UpdateDetails from '../components/updateDetails.vue'
import UpdateDetailsEnt from '../components/updateDetailsEnt.vue'
export default {
  metaInfo: {
    title: ' - USA ბაზები'
  },
  components: {
    UpdateDetails,
    UpdateDetailsEnt
  },
  data () {
    return {
      header: {
        headers: {
          accept: 'text/plain',
          Authorization: 'Bearer ' + this.$store.getters.getAccessToken
        }
      },
      updateDates: [],
      updateDatesENT: [],
      updateDetailItemList: [],
      updateDetailItemListENT: [],
      curtab: '',
      curtabENT: '',
      regex: /"(.*?)"/g,
      updateItem: {
        upjurtype: 1
      },
      loading: false
    }
  },
  beforeCreate () {
    this.countriesList = this.$store.getters.GetCountriesList
  },
  created () {
    this.loading = true
    // BaseService.GetUNIndividualsDiff(this.header).then((res) => {
    //   if (res.data.success) {
    //     console.log(res.data)
    //     this.UN_IND_UPDATES_COUNT = res.data.result.length
    //     this.UN_IND_UPDATES = res.data.result
    //     this.loading = false
    //   } else {
    //     this.$swal({
    //       title: 'ყურადღება!',
    //       text:
    //         'ვერ მოხერხდა მონაცემების ჩატვირთვა, გთხოვთ თავიდან გაიაროთ ავტორიზაცია',
    //       type: 'warning',
    //       showCancelButton: false,
    //       confirmButtonColor: '#DD6B55',
    //       confirmButtonText: 'თანხმობა',
    //       heightAuto: false,
    //       customClass: 'e-nusx-8',
    //       confirmButtonClass: 'e-mtavr-17',
    //       keydownListenerCapture: true
    //     }).then((result) => {
    //       if (result.value) {
    //         this.$router.replace(this.$route.query.redirect || '/')
    //       }
    //     })
    //   }
    // })
    BaseService.GetIndividualUpdateDetailsDatesOFAC(this.header).then((res) => {
      this.loading = false
      this.updateDates = res.data.result
    })
    BaseService.GetCompanyUpdateDetailsDatesOFAC(this.header).then((res) => {
      this.loading = false
      this.updateDatesENT = res.data.result
    })
  },
  methods: {
    changeTab (tab) {
      this.curTab = tab
    },
    thistab () {
      return this.curTab
    },
    changeTabENT (tab) {
      this.curTabENT = tab
    },
    thistabENT () {
      return this.curTabENT
    },
    loadUpdateData (date) {
      BaseService.GetIndividualUpdateDetailsByDateOFAC(this.header, date).then((res) => {
        this.loading = false
        // res.data.result.forEach(element => {
        //   element.datasets = JSON.parse(element.datasets)
        // })
        // console.log(res.data.result)
        this.updateDetailItemList = res.data.result
      })
    },
    loadUpdateDataENT (date) {
      BaseService.GetCompanyUpdateDetailsByDateOFAC(this.header, date).then((res) => {
        this.loading = false
        // res.data.result.forEach(element => {
        //   element.datasets = JSON.parse(element.datasets)
        // })
        console.log(res.data.result)
        this.updateDetailItemListENT = res.data.result
      })
    },
    PassUpdateDetails (data, upjurtype) {
      this.updateItem.upjurtype = upjurtype
      this.updateItem = data
    }
  },
  filters: {
    momentDate (date) {
      return moment(date).format('DD.MM.YYYY')
    },
    momentDateTime (date) {
      return moment(date).format('DD.MM.YYYY HH:mm:SS')
    }
  },
  computed: {
    getCountryFullName () {
      return (countryCode) => {
        if (this.countriesList.length === 0) {
          this.countriesList = this.$store.getters.GetCountriesList
        }
        const country = this.countriesList.find(item => item.twoCharCountryCode === countryCode)
        return country ? country.countryName : 'Undefined'
      }
    },
    objectArray () {
      return (data) => {
        data = JSON.parse(data)
        // console.log(data)
        // console.log(data.split(this.regex))
        // return data.map(item => ({ [item]: item })) // Create object with each item as key and value
        return data
      }
    },
    filterEvidences () {
      return () => {
        const possibleDS = this.businessDetails.envidencePossibleDS.filter(item => item.count > 0)
        return possibleDS
      }
    },
    Evi4Tab () {
      return (db) => {
        const eviList = this.businessDetails.evidences.filter(item => item.datasets.includes(db))
        console.log(eviList)
        return eviList
      }
    },
    filterEvs4San () {
      return (id) => {
        const possibleDS = this.businessDetails.evidences.filter(item => item.evidenceId === id)
        return possibleDS
      }
    }
  }
}
</script>
